/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Team_Created_SuccessInputs */

const en_team_manager_team_created_success = /** @type {(inputs: Team_Manager_Team_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New team created successfully`)
};

const fr_team_manager_team_created_success = /** @type {(inputs: Team_Manager_Team_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle équipe créée avec succès`)
};

const de_team_manager_team_created_success = /** @type {(inputs: Team_Manager_Team_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Team erfolgreich gebildet`)
};

const it_team_manager_team_created_success = /** @type {(inputs: Team_Manager_Team_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo team creato con successo`)
};

const ru_team_manager_team_created_success = /** @type {(inputs: Team_Manager_Team_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новая команда успешно создана`)
};

const es_team_manager_team_created_success = /** @type {(inputs: Team_Manager_Team_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo equipo creado exitosamente`)
};

const zh_cn2_team_manager_team_created_success = /** @type {(inputs: Team_Manager_Team_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新团队已成功组建。`)
};

const ja_team_manager_team_created_success = /** @type {(inputs: Team_Manager_Team_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいチームが正常に作成されました`)
};

const hi_team_manager_team_created_success = /** @type {(inputs: Team_Manager_Team_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई टीम का गठन सफलतापूर्वक हो गया है।`)
};

const pt_pt2_team_manager_team_created_success = /** @type {(inputs: Team_Manager_Team_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova equipe criada com sucesso`)
};

/**
* | output |
* | --- |
* | "New team created successfully" |
*
* @param {Team_Manager_Team_Created_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_team_created_success = /** @type {((inputs?: Team_Manager_Team_Created_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Team_Created_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_team_created_success(inputs)
	if (locale === "de") return de_team_manager_team_created_success(inputs)
	if (locale === "it") return it_team_manager_team_created_success(inputs)
	if (locale === "ru") return ru_team_manager_team_created_success(inputs)
	if (locale === "es") return es_team_manager_team_created_success(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_team_created_success(inputs)
	if (locale === "ja") return ja_team_manager_team_created_success(inputs)
	if (locale === "hi") return hi_team_manager_team_created_success(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_team_created_success(inputs)
	return en_team_manager_team_created_success(inputs)
});